(function () {
  angular
    .module("ROGER")

    .controller("TradeInDetailController", [
      "$scope",
      "$q",
      "$http",
      "$sessionStorage",
      "$routeParams",
      "Upload",
      "$decisionBox",
      "$location",
      "$notifications",
      "$filter",
      "FileSaver",
      "Blob",
      "FileUploader",
      "$translate",
      "$user",
      "$oidc",
      function (
        scope,
        $q,
        http,
        sessionStorage,
        routeParams,
        Upload,
        decisionBox,
        location,
        notifications,
        filter,
        FileSaver,
        Blob,
        FileUploader,
        translate,
        user,
        oidc
      ) {
        scope.$storage = sessionStorage;
        scope.user = user;
        scope.tradeInId = routeParams.id;
        scope.attachmentTypes = [];
        scope.formData = {
          description: ""
        };

        scope.uploader = new FileUploader({
          removeAfterUpload: true,
          autoUpload: false
        });

        scope.uploader.filters.push({
          name: 'fileSizeFilter',
          fn: function (item, options) {
            var validFileSize = item.size <= scope.model.FileMaxSize;
            if (!validFileSize) {
              translate('FileSizeAboveLimit', { value: sizeFormat(scope.model.FileMaxSize) }).then(function (translation) {
                notifications.addError(translation, item.name);
              })
            }
            return validFileSize;
          }
        });

        scope.uploader.onAfterAddingAll = function (addedFileItems) {
          var code = addedFileItems[0].attachmentType;

          if (addedFileItems.length <= scope.model.fileLimit(code)) {
            addedFileItems.forEach(function (item) {
                return item.upload();
            })
          }
        };

        function sizeFormat(value) {
          if (!value) return "";

          var bytes = parseInt(value);
          if (bytes === 0) return "0 B";

          var k = 1024;
          var sizes = ["B", "KB", "MB", "GB"];
          var i = Math.floor(Math.log(bytes) / Math.log(k));
          return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
        }

        scope.canUpload = function (code) {
          return !(scope.model.fileLimit(code) == 0 || scope.uploader.isCodeUploading(code));
        }

        scope.uploader.isCodeUploading = function (code) {
          return this.queue.filter(function (item) {
            return item.attachmentType === code && item.isUploading;
          }).length > 0;
        }

        scope.uploader.uploadItem = function (value) {
          value.isUploading = true;
          var fd = new FormData();
          fd.append('file', value._file);

          return http.post("api/retailer/" +
            scope.$storage.retailer.Id +
            "/trade-in/" +
            routeParams.id +
            "/type/" +
            value.attachmentType +
            "/attachment", fd, {
            headers: {
              'Content-Type': undefined,
              Authorization: oidc.current.token_type + " " + oidc.current.access_token
            },
            transformRequest: angular.identity
          }).then(function (response) {
            scope.model.Attachments = scope.model.Attachments.concat(
              response.data
            );

            value.isUploading = false;
            if (value.removeAfterUpload)
              value.remove();
          }, function (response) {
            value.isUploading = false;
          });
        }

        scope.$watch("$storage.retailer", function (newValue, oldValue) {
          if (oldValue.Id !== newValue.Id) {
            location.path("/trade-in");
          }
        });

        scope.getNotUploadedFilesWithCode = function (code) {
          if (!scope.uploader.queue)
            return null;

          return scope.uploader.queue.filter(function (item) {
            return item.attachmentType === code;
          });
        }

        scope.getFilesWithCode = function (code) {
          if (!scope.model || typeof scope.model.Attachments === "undefined")
            return null;

          return scope.model.Attachments.filter(function (item) {
            return item.TypeCode === code;
          });
        };

        scope.deleteFile = function (attachment) {
          attachment.isDeleting = true;
          return http
            .delete(
              "api/retailer/" +
              scope.$storage.retailer.Id +
              "/trade-in/" +
              routeParams.id +
              "/attachment/" +
              attachment.Id, {
              headers: {
                Authorization: oidc.current.token_type + " " + oidc.current.access_token
              }
            }
            )
            .then(function (response) {
              scope.model.Attachments = scope.model.Attachments.filter(function (
                item
              ) {
                return item.Id !== attachment.Id;
              });
            }, function (response) {
              attachment.isDeleting = false;
            });
        };

        function _loadTradeIn() {
          return http
            .get(
              "api/retailer/" +
              scope.$storage.retailer.Id +
              "/trade-in/" +
              routeParams.id, {
              headers: {
                Authorization: oidc.current.token_type + " " + oidc.current.access_token
              }
            }
            )
            .then(function (response) {
              scope.model = response.data;
              scope.formData.description = response.data.Description;
              scope.model.fileLimit = function (code) {
                return (
                  scope.model.FileMaxCount - scope.getFilesWithCode(code).length
                );
              };
            });
        }

        function _attachmentTypes() {
          return http
            .get("api/attachment-type", {
              headers: {
                Authorization: oidc.current.token_type + " " + oidc.current.access_token
              }
            }).then(
                function (response) {
                    if (response.data.length > 0) {
                        scope.attachmentTypes = [response.data[0]];
                    } else {
                        translate(['TradeInAttachmentNoDataError.Message', 'TradeInAttachmentNoDataError.Name'])
                            .then(function (translations) {
                                notifications.addError(
                                    translations['TradeInAttachmentNoDataError.Name'],
                                    translations['TradeInAttachmentNoDataError.Message']
                                );
                            });
                    }
                },
                function () {
                    notifications.addError(
                        'Error',
                        'An error occured when loading attachment type'
                    );
                }
            );
        }
         
        scope.downloadAttachment = function (id) {
          _downloadAttachment(id, scope.tradeInId, scope.$storage.retailer.Id);
        }

        function _downloadAttachment(id, tradeInId, retailerId) {
          return http
            .get("/api/retailer/" + retailerId + "/trade-in/" + tradeInId + "/attachment/" + id + "/download", {
              responseType: 'arraybuffer',
              headers: {
                Authorization: oidc.current.token_type + " " + oidc.current.access_token
              },
              skipInterceptors: true
            })
            .then(function (response) {
              var contentDisposition = response.headers("content-disposition");
              var regex = /filename="*([^"].+[^"])"*;/g;
              var result = regex.exec(contentDisposition);
              var fileName = result[1];
              var data = new Blob([response.data], { type: response.headers("content-type") });
              FileSaver.saveAs(data, fileName);
            }, function (data) {
              translate(['TradeInAttachmentDownloadError.Message', 'TradeInAttachmentDownloadError.Name'])
                .then(function (translations) {
                  notifications.addError(
                    translations['TradeInAttachmentDownloadError.Name'],
                    translations['TradeInAttachmentDownloadError.Message']
                  );
                }, function () {
                  notifications.addError(
                    'Error',
                    'An error occured when downloading attachments'
                  );
                })
            });
        }

        scope.downloadAllAttachments = function () {
            if (scope.model && scope.model.Attachments) {
                scope.model.Attachments.forEach(attachment => {
                    _downloadAttachment(attachment.Id, scope.tradeInId, scope.$storage.retailer.Id);
                });
            }
        };

        scope.save = function () {
          return _checkQueue().then(function () {
            return _save();
          }, function () {
            return $q.reject();
          }).then(function () {
            scope.refresh();
          });
        };

        function _checkQueue() {
          if (scope.uploader.queue.length === 0) {
            return $q.resolve();
          }

          var errors = [];

          for (var attachmentType of scope.attachmentTypes) {
            if (scope.getNotUploadedFilesWithCode(attachmentType.Code).length > scope.model.fileLimit(attachmentType.Code)) {
              errors.push(filter("translate")(attachmentType.Code));
            }
          }

          if (errors.length !== 0) {
            notifications.addError("AttachmentTypeFileOverflow", errors.join(", "));
            return $q.reject();
          }

          return $q.resolve();
        }

        function _save() {
          if (!scope.tradeInForm.$valid) {
            notifications.addError("TradeInFormInvalidHeader", 'TradeInFormInvalidBody');
            return $q.reject();
          }

          var promises = [];

          scope.uploader.queue.forEach(function (item) {
            promises.push(item.upload());
          });

          promises
            .push(http({
              method: "PUT",
              url:
                "api/retailer/" +
                scope.$storage.retailer.Id +
                "/trade-in/" +
                routeParams.id,
              data: { description: scope.formData.description },
              headers: {
                Authorization: oidc.current.token_type + " " + oidc.current.access_token
              }
            }));

          return Promise.all(promises);
        }

        function _validateSend() {
          var valid = true;
          var values = [];
          for (var index = 0; index < scope.attachmentTypes.length; index++) {
            var attachmentType = scope.attachmentTypes[index];

            var attachments = scope.getFilesWithCode(attachmentType.Code);

            if (
              attachmentType.Required === true &&
              (!attachments || attachments.length === 0)
            ) {
              values.push(filter("translate")(attachmentType.Code));
              valid = false;
            }
          }

          if (!valid && values.length !== 0)
            notifications.addError("RequiredFields", values.join(", "));

          return valid;
        }

        function _send() {
          return http
            .put(
              "api/retailer/" +
              scope.$storage.retailer.Id +
              "/trade-in/" +
              routeParams.id +
              "/SNT",
              null,
              {
                headers: {
                  Authorization: oidc.current.token_type + " " + oidc.current.access_token
                }
              }
            );
        }

        scope.send = function () {
          return decisionBox
            .showConfirm(
              "SaveBeforeSend",
              "SaveTradeInBeforeSend",
              "Save",
              "Skip"
            )
            .result
            .then(function () {
              return _checkQueue().then(_save);
            }, function (data) {
              if (data == "backdrop click") return $q.reject();
              return $q.resolve();
            })
            .then(_loadTradeIn)
            .then(function () {
              if (!_validateSend()) {
                return $q.reject();
              }
              return $q.resolve();
            })
            .then(_send)
            .then(
              function () {
                location.path("/trade-in");
              },
              function () { }
            );
        };

        scope.refresh = function () {
          _attachmentTypes();
          _loadTradeIn();
        };
        scope.refresh();

        if (scope.$storage.retailer !== null && scope.$storage.retailer.Id > 0) {
          scope.refresh();
        }
      }
    ]);
})();
